export const EMPTY_REQUEST_BODY = {} as Record<string, never>;
